<script setup lang="ts">
  import { TravelDirection } from '@/shared/types/common.types'
  import { computed, defineAsyncComponent } from 'vue'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowTravelDatesWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelDatesWidget/FlowTravelDatesWidget.vue')
  )
  const FlowTravelDatesWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelDatesWidgetQC/FlowTravelDatesWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isDatesQcEnabled = computed(() => featuresStore.isDatesQcEnabled)
</script>

<template>
  <FlowTravelDatesWidgetQC v-if="isDatesQcEnabled" :type-of-travel="TravelDirection.INBOUND" />
  <FlowTravelDatesWidget v-else :type-of-travel="TravelDirection.INBOUND" />
</template>
